import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { FaHome, FaLayerGroup, FaBook, FaChalkboardTeacher, FaGraduationCap,
  FaBullhorn, FaCalendarAlt, FaBookOpen, FaMoneyBill, FaCog, FaChartBar,
} from 'react-icons/fa';
import AdminDashboard from './Dashboard';
import Analytics      from './Analytics';
import Grades         from './Grades';
import Subjects       from './Subjects';
import Teachers       from './Teachers';
import Learners       from './Learners';
import Notices        from './Notices';
import Terms          from './Terms';
import Library        from './Library';
import Fees           from './Fees';
import Events         from './Events';
import Settings       from './Settings';

const navItems = [
  { type: 'section', label: 'Overview' },
  { to: '/admin',           label: 'Dashboard',       icon: FaHome },
  { to: '/admin/analytics', label: 'Analytics',       icon: FaChartBar },
  { type: 'section', label: 'School Setup' },
  { to: '/admin/settings', label: 'Logo & Theme',    icon: FaCog },
  { to: '/admin/terms',    label: 'Terms',            icon: FaCalendarAlt },
  { to: '/admin/grades',   label: 'Grades',           icon: FaLayerGroup },
  { to: '/admin/subjects', label: 'Subjects',         icon: FaBook },
  { type: 'section', label: 'People' },
  { to: '/admin/teachers', label: 'Teachers',         icon: FaChalkboardTeacher },
  { to: '/admin/learners', label: 'Learners',         icon: FaGraduationCap },
  { type: 'section', label: 'Communication' },
  { to: '/admin/notices',  label: 'Notice Board',     icon: FaBullhorn },
  { to: '/admin/events',   label: 'Events',           icon: FaCalendarAlt },
  { type: 'section', label: 'Resources' },
  { to: '/admin/library',  label: 'Library',          icon: FaBookOpen },
  { to: '/admin/fees',     label: 'Fees',             icon: FaMoneyBill },
];

export default function AdminApp() {
  return (
    <DashboardLayout sidebarItems={navItems}>
      <Routes>
        <Route index              element={<AdminDashboard />} />
        <Route path="analytics"   element={<Analytics />} />
        <Route path="grades"      element={<Grades />} />
        <Route path="subjects"    element={<Subjects />} />
        <Route path="teachers"    element={<Teachers />} />
        <Route path="learners"    element={<Learners />} />
        <Route path="notices"     element={<Notices />} />
        <Route path="terms"       element={<Terms />} />
        <Route path="library"     element={<Library />} />
        <Route path="fees"        element={<Fees />} />
        <Route path="events"      element={<Events />} />
        <Route path="settings"    element={<Settings />} />
        <Route path="*"           element={<Navigate to="/admin" replace />} />
      </Routes>
    </DashboardLayout>
  );
}
